export class BancoCedente {
  CedenteRazaoSocial = null;
  CedenteNomeFantasia = null;
  CedenteCPFCNPJ = null;
  CedenteEnderecoLogradouro = null;
  CedenteEnderecoNumero = null;
  CedenteEnderecoComplemento = null;
  CedenteEnderecoBairro = null;
  CedenteEnderecoCEP = null;
  CedenteEnderecoCidadeIBGE = null;
  CedenteTelefone = null;
  CedenteEmail = null;

  constructor(empresa) {
    this.CedenteRazaoSocial = empresa.razaoSocial;
    this.CedenteNomeFantasia = empresa.fantasia;
    this.CedenteCPFCNPJ = empresa.cnpjCpf;
    this.CedenteEnderecoLogradouro = empresa.enderecoLogradouro;
    this.CedenteEnderecoNumero = empresa.enderecoLogradouroNumero;
    this.CedenteEnderecoComplemento = empresa.enderecoComplemento;
    this.CedenteEnderecoBairro = empresa.enderecoBairro;
    this.CedenteEnderecoCEP = empresa.enderecoCep;
    this.CedenteEnderecoCidadeIBGE = empresa.cidade?.codigoIbge;
    this.CedenteTelefone = empresa.telefone ?? empresa.celular;
    this.CedenteEmail = empresa.email;
  }
}
